import QueryString from 'query-string';

(() => {
    const {
        reason,
        domain,
        question,
    } = QueryString.parse(window.location.search);

    const reasonInput = document.getElementById(`edit-reason-${reason}`);
    const domainInput = document.getElementById('edit-domain');
    const questionInput = document.getElementById('edit-question');

    if (reason && reasonInput) {
        reasonInput.checked = true;
    }

    if (domain && domainInput) {
        domainInput.value = domain;
    }

    if (question && questionInput) {
        questionInput.value = question;
    }
})();
